export const blockIconsPrivacyandsecurityDisabledVisibleNew = (
	<span className='material-symbols-outlined'>disabled_visible</span>
);
